// extracted by mini-css-extract-plugin
module.exports = {"link":"HighlightedCourse_link__JafMx","title":"HighlightedCourse_title__ha9VH","button":"HighlightedCourse_button__kIWcX","icon":"HighlightedCourse_icon__buWtZ"};